<template>
  <v-container class="settings-container">
    <v-card class="mb-6 settings-card" elevation="2">
      <v-card-title class="primary-header">
        <v-icon class="mr-2" dark>mdi-cog</v-icon>
        System Settings
      </v-card-title>

      <v-card-text>
        <div class="settings-grid">
          <div class="setting-section" v-if="showRecordPublicEdit">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="mr-2">mdi-record-circle</v-icon>
              <span class="setting-title">Public Recording Permissions:</span>
            </div>
            <v-radio-group v-model="radioGroup.public_record_permission" row class="mt-2">
              <v-radio v-for="option in publicRecordPermissionOptions" :key="option.value" :label="option.label"
                :value="option.value" color="#0d2c6d" class="ml-1"></v-radio>
            </v-radio-group>
          </div>

          <div class="setting-section" v-if="showRecordPrivateEdit">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="mr-2">mdi-record-circle</v-icon>
              <span class="setting-title">Private Recording Permissions:</span>
            </div>
            <v-radio-group v-model="radioGroup.all_can_record_private" row class="mt-2">
              <v-radio v-for="option in groupType" :key="option" :label="option" :value="option" color="#0d2c6d"
                class="ml-1"></v-radio>
            </v-radio-group>
          </div>

          <div class="setting-section">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="mr-2">mdi-translate</v-icon>
              <span class="setting-title">Language:</span>
            </div>
            <v-radio-group v-model="radioGroup.language" row class="mt-2">
              <v-radio v-for="option in languageList" :key="option" :label="option" :value="option" color="#0d2c6d"
                class="ml-1"></v-radio>
            </v-radio-group>
          </div>

          <div class="setting-section">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="mr-2">mdi-account-multiple-plus</v-icon>
              <span class="setting-title">Add subscribers permission:</span>
            </div>
            <v-radio-group v-model="radioGroup.all_can_add_subscribers" row class="mt-2">
              <v-radio v-for="option in addSubscribePermission" :key="option" :label="option" :value="option"
                color="#0d2c6d" class="ml-1"></v-radio>
            </v-radio-group>
          </div>

          <div class="setting-section">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="mr-2">mdi-phone</v-icon>
              <span class="setting-title">Open line for everyone:</span>
            </div>
            <v-radio-group v-model="radioGroup.isIvrOpen" row class="mt-2">
              <v-radio v-for="option in addSubscribePermission" :key="option" :label="option" :value="option"
                color="#0d2c6d" class="ml-1"></v-radio>
            </v-radio-group>
          </div>

          <div class="setting-section" v-if="showShareRecordEdit">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="mr-2">mdi-share-variant</v-icon>
              <span class="setting-title">Message Sharing:</span>
            </div>
            <v-radio-group v-model="radioGroup.share_record" row class="mt-2">
              <v-radio v-for="option in addSubscribePermission" :key="option" :label="option" :value="option"
                color="#0d2c6d" class="ml-1"></v-radio>
            </v-radio-group>
          </div>

          <!-- Conference Room Opening -->
          <div class="setting-section">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="mr-2">mdi-account-group</v-icon>
              <span class="setting-title">Conference Room Opening:</span>
            </div>
            <v-radio-group v-model="radioGroup.all_can_open_conference" row class="mt-2">
              <v-radio v-for="option in groupType" :key="option" :label="option" :value="option" color="#0d2c6d"
                class="ml-1"></v-radio>
            </v-radio-group>
          </div>

          <!-- Conference Join/Leave Sound -->
          <div class="setting-section">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="mr-2">mdi-bullhorn</v-icon>
              <span class="setting-title">Conference join/leave sound:</span>
            </div>
            <v-radio-group v-model="radioGroup.conference_join_leave_sound" row class="mt-2">
              <v-radio v-for="option in conferenceJoinLeaveOptions" :key="option" :label="option" :value="option"
                color="#0d2c6d" class="ml-1"></v-radio>
            </v-radio-group>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-card class="mb-6 settings-card" elevation="2">
      <v-card-title class="secondary-header">
        <v-icon class="mr-2">mdi-shield-lock</v-icon>
        Security & Privacy
      </v-card-title>

      <v-card-text>
        <div class="setting-section">
          <div class="setting-header">
            <v-icon color="#0d2c6d" class="mr-2">mdi-lock</v-icon>
            <span class="setting-title">System Password:</span>
          </div>
          <v-radio-group v-model="radioGroup.system_password" row class="mt-2">
            <v-radio v-for="option in systemPasswordOptions" :key="option" :label="option" :value="option"
              color="#0d2c6d" class="ml-1"></v-radio>
          </v-radio-group>

          <v-slide-y-transition>
            <v-text-field v-if="radioGroup.system_password === 'Enable'" v-model="details.system_password"
              label="Enter password (4 digits)" maxlength="4" outlined dense class="mt-3 password-field" :rules="[
                v => !v || /^\d+$/.test(v) || 'Password must contain digits only',
                v => !v || v.length === 4 || 'Password must be 4 digits'
              ]"></v-text-field>
          </v-slide-y-transition>
        </div>

        <!-- Skip System Password For -->
        <v-slide-y-transition>
          <div class="setting-section alternate" v-if="radioGroup.system_password === 'Enable'">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="mr-2">mdi-account-key</v-icon>
              <span class="setting-title">Skip system password for:</span>
            </div>
            <v-radio-group v-model="radioGroup.skipSysPasswordFor" row class="mt-2">
              <v-radio v-for="option in skipSysPasswordForOptions" :key="option.value" :label="option.label"
                :value="option.value" color="#0d2c6d" class="ml-1"></v-radio>
            </v-radio-group>
          </div>
        </v-slide-y-transition>

        <div class="setting-section alternate">
          <div class="setting-header">
            <v-icon color="#0d2c6d" class="mr-2">mdi-delete-clock</v-icon>
            <span class="setting-title">Delete recordings after 30 days:</span>
          </div>
          <v-radio-group v-model="radioGroup.delete_after_thirty_days" row class="mt-2">
            <v-radio v-for="option in deleteAfterThirtyDays" :key="option.name" :label="option.name"
              :value="option.value" color="#0d2c6d" class="ml-1"></v-radio>
          </v-radio-group>
        </div>
      </v-card-text>
    </v-card>

    <v-card class="mb-6 settings-card" elevation="2">
      <v-card-title class="tertiary-header">
        <v-icon class="mr-2">mdi-earth</v-icon>
        Regional Settings
      </v-card-title>

      <v-card-text>
        <div class="setting-section">
          <div class="setting-header">
            <v-icon color="#0d2c6d" class="mr-2">mdi-clock-time-four</v-icon>
            <span class="setting-title">Timezone (UTC):</span>
          </div>
          <v-autocomplete v-model="radioGroup.timezone" :items="timezones" item-text="label" item-value="value"
            label="Select Timezone" outlined dense hide-details="auto" class="mt-2 timezone-select"></v-autocomplete>
        </div>
      </v-card-text>
    </v-card>

    <div class="d-flex justify-end mb-8">
      <v-btn color="primary" x-large :loading="progressShow" :disabled="progressShow" @click="saveChanges"
        class="save-button">
        <v-icon left>mdi-content-save</v-icon>
        Save Changes
      </v-btn>
    </div>

    <v-overlay :value="progressShow" absolute>
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </v-container>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'
import moment from 'moment-timezone';

export default {
  components: {
    SnackBar,
  },
  data: () => ({
    snackbar: false,
    snackbarColorBt: "success",
    snacbarText: "",
    radioGroup: {
      public_record_permission: null,
      all_can_record_private: null,
      timezone: '', // selected value
      language: null,
      all_can_add_subscribers: null,
      delete_after_thirty_days: null,
      system_password: null,
      skipSysPasswordFor: 'none',
      isIvrOpen: null,
      share_record: null,
      all_can_open_conference: null,
      conference_join_leave_sound: null
    },
    progressShow: false,
    groupType: ["Everyone", "Admins Only"],
    publicRecordPermissionOptions: [
      { label: "Everyone", value: "all" },
      { label: "Admins Only", value: "managers" },
      { label: "Everyone - With Admin Approval", value: "allAdminApproval" }
    ],
    languageList: ["Hebrew", "Yiddish (IL)"],
    addSubscribePermission: ["Yes", "No"],
    deleteAfterThirtyDays: [{ name: "Yes", value: true }, { name: "No", value: false }],
    systemPasswordOptions: ["Inactive", "Enable"],
    skipSysPasswordForOptions: [
      { label: "Nobody", value: "none" },
      { label: "Managers and Owners", value: "manager" },
      { label: "Owners only", value: "owner" },
      { label: "Manually added subscribers", value: "manualJoinSubscriber" }
    ],
    conferenceJoinLeaveOptions: ["Everyone", "Nobody"],
    details: {},
    showRecordPublicEdit: true,
    showRecordPrivateEdit: true,
    showShareRecordEdit: true,
  }),
  computed: {
    timezones() {
      return this.getAllTimezones();
    },
  },
  methods: {
    async getSettingsDetails() {
      try {
        this.progressShow = true;
        let token = localStorage.getItem("token");
        let api = process.env.VUE_APP_BASE_URL + `/settings/get_settings_details`;
        const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
        const jsonObject = await res.json();

        if (res.status >= 400) {
          this.showSnackBar("Error fetching data", "error");
        } else if (res.status === 200) {
          this.details = jsonObject;
          this.setSystemSettings();
        }
      } catch (error) {
        this.showSnackBar("Error get files: " + error, "error");
      } finally {
        this.progressShow = false;
      }
    },

    getAllTimezones() {
      return moment.tz.names().map(tz => {
        const offset = moment.tz(tz).utcOffset();
        const hours = Math.floor(offset / 60);
        const minutes = Math.abs(offset % 60);
        const label = `(UTC${hours >= 0 ? '+' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}) ${tz}`;

        return {
          label,
          value: tz
        };
      });
    },

    setSystemSettings() {
      if (!this.details.exten_permissions.all_can_record_public) {
        this.showRecordPublicEdit = false;
      }

      if (!this.details.exten_permissions.all_can_record_private) {
        this.showRecordPrivateEdit = false;
      }

      if (!this.details.exten_permissions.share_record) {
        this.showShareRecordEdit = false;
      }

      this.radioGroup.public_record_permission = this.details.general_settings.public_record_permission || "all";

      if (this.details.general_settings.all_can_record_private) {
        this.radioGroup.all_can_record_private = "Everyone"
      } else {
        this.radioGroup.all_can_record_private = "Admins Only"
      }

      if (this.details.general_settings.language === 'he') {
        this.radioGroup.language = "Hebrew"
      } else if (this.details.general_settings.language === 'en') {
        this.radioGroup.language = "English"
      } else if (this.details.general_settings.language === 'yi_il') {
        this.radioGroup.language = "Yiddish (IL)"
      } else {
        this.radioGroup.language = "Yiddish (US)"
      }

      if (this.details.general_settings.all_can_add_subscribers) {
        this.radioGroup.all_can_add_subscribers = "Yes"
      } else {
        this.radioGroup.all_can_add_subscribers = "No"
      }

      if (this.details.general_settings.isIvrOpen) {
        this.radioGroup.isIvrOpen = "Yes"
      } else {
        this.radioGroup.isIvrOpen = "No"
      }

      if (this.details.general_settings.share_record) {
        this.radioGroup.share_record = "Yes"
      } else {
        this.radioGroup.share_record = "No"
      }

      if (this.details.general_settings.all_can_open_conference) {
        this.radioGroup.all_can_open_conference = "Everyone"
      } else {
        this.radioGroup.all_can_open_conference = "Admins Only"
      }

      const joinLeaveSound = this.details.general_settings.conference_join_leave_sound;
      if (joinLeaveSound === 'all') {
        this.radioGroup.conference_join_leave_sound = "Everyone"
      } else {
        this.radioGroup.conference_join_leave_sound = "Nobody"
      }

      if (this.details.system_password) {
        this.radioGroup.system_password = "Enable"
      } else {
        this.radioGroup.system_password = "Inactive"
      }

      this.radioGroup.skipSysPasswordFor = this.details.general_settings.skipSysPasswordFor || 'none';

      if (this.details.delete_settings.delete_after_thirty_days) {
        this.radioGroup.delete_after_thirty_days = true
      } else {
        this.radioGroup.delete_after_thirty_days = false
      }

      this.radioGroup.timezone = this.details.general_settings.timezone;
    },

    async saveChanges() {
      try {
        if (this.radioGroup.system_password === "Enable" && this.details.system_password) {
          const numberRegex = /^\d+$/; // Only numeric characters
          const isValidFormat = numberRegex.test(this.details.system_password);
          if (!isValidFormat) {
            return this.showSnackBar("Password must contain digits only", "error");
          }
          if (this.details.system_password.length != 4) {
            return this.showSnackBar("Password must be 4 digits", "error");
          }
        }

        const updatedObj = {
          system_password: this.radioGroup.system_password === "Enable" ? this.details.system_password : "",
          delete_settings: { delete_after_thirty_days: this.radioGroup.delete_after_thirty_days },
          general_settings: {
            language: this.radioGroup.language === "Hebrew" ? "he" :
              this.radioGroup.language === "English" ? "en" :
                this.radioGroup.language === "Yiddish (IL)" ? "yi_il" : "yi-us",
            isIvrOpen: this.radioGroup.isIvrOpen === "Yes" ? true : false,
            public_record_permission: this.radioGroup.public_record_permission,
            all_can_record_private: this.radioGroup.all_can_record_private === "Everyone" ? true : false,
            all_can_add_subscribers: this.radioGroup.all_can_add_subscribers === "Yes" ? true : false,
            share_record: this.radioGroup.share_record === "Yes" ? true : false,
            all_can_open_conference: this.radioGroup.all_can_open_conference === "Everyone" ? true : false,
            conference_join_leave_sound: this.radioGroup.conference_join_leave_sound === "Everyone" ? "all" : "none",
            timezone: this.radioGroup.timezone,
            skipSysPasswordFor: this.radioGroup.system_password === "Enable" ? this.radioGroup.skipSysPasswordFor : 'none',
          }
        }

        this.progressShow = true;
        const detailsJSON = JSON.stringify({ updatedObj });
        let token = localStorage.getItem("token");
        let api = process.env.VUE_APP_BASE_URL + `/settings/save_changes`;
        const res = await fetch(api, ApiServices.requestOptions("PUT", detailsJSON, token));

        if (res.status >= 400) {
          this.showSnackBar("Error saving changes", "error");
        } else if (res.status === 200) {
          this.showSnackBar("Changes updated successfully!", "success");
          this.$store.commit('SET_TIMEZONE', this.radioGroup.timezone);
        }
      } catch (error) {
        this.showSnackBar("Error save changes: " + error, "error");
      } finally {
        this.progressShow = false;
      }
    },

    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color === "error" ? "red" : "green";
      this.snackbar = true;
    },
  },

  mounted() {
    this.getSettingsDetails();
  },
}
</script>

<style scoped>
.settings-container {
  max-width: 1200px;
  margin: 0 auto;
  direction: ltr;
  /* Changed to ltr */
  font-family: 'Heebo', sans-serif;
}

.settings-card {
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.settings-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
}

.primary-header {
  background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 16px;
}

.secondary-header {
  background: linear-gradient(135deg, #ffb91a 0%, #ffd166 100%);
  color: #0d2c6d;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 16px;
}

.tertiary-header {
  background: linear-gradient(135deg, #6a6aec 0%, #8a8aff 100%);
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 16px;
}

.settings-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
}

.settings-grid>.setting-section {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-right: 1px solid rgba(0, 0, 0, 0.05);
}

.settings-grid>.setting-section:nth-child(even) {
  border-right: none;
}

.setting-section {
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.setting-section.alternate {
  background-color: rgba(0, 0, 0, 0.02);
}

.setting-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.setting-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #0d2c6d;
}

.timezone-select {
  max-width: 400px;
}

.password-field {
  max-width: 200px;
}

.save-button {
  background: linear-gradient(0deg, rgba(255, 185, 26, 1) 0%, rgba(255, 185, 26, 0.8) 100%);
  color: #0d2c6d;
  font-weight: bold;
  font-size: 1.1rem;
  padding: 0 32px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.save-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* Radio button styling */
:deep(.v-radio label) {
  font-weight: 500;
}

:deep(.v-input--radio-group__input) {
  margin-top: 8px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .settings-container {
    padding: 16px;
  }

  .settings-grid {
    grid-template-columns: 1fr;
  }

  .settings-grid>.setting-section {
    border-right: none;
  }

  .primary-header,
  .secondary-header,
  .tertiary-header {
    font-size: 1.25rem;
  }

  .setting-title {
    font-size: 1rem;
  }
}

@media (max-width: 600px) {
  .save-button {
    width: 100%;
  }

  :deep(.v-radio-group) {
    flex-direction: column !important;
  }

  :deep(.v-radio) {
    margin-bottom: 8px;
  }
}
</style>